import { ArrowRight, Phone } from "lucide-react";

export default function CTASection() {
  const scrollTo = (id) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section data-testid="cta-section" className="py-24 md:py-32 bg-navy-dark relative">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold/20 to-transparent" />
      
      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center space-y-8 animate-on-scroll">
        <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl tracking-tight text-white leading-tight">
          Your legal matter deserves{" "}
          <em className="text-gold not-italic">partner-level attention.</em>
        </h2>
        
        <p className="text-base md:text-lg text-gray-400 font-body max-w-2xl mx-auto">
          Book a confidential consultation with LexSant today.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center pt-4">
          <button
            onClick={() => scrollTo("#contact")}
            data-testid="cta-book-btn"
            className="bg-gold text-navy-dark px-10 py-4 text-sm font-semibold tracking-wide hover:bg-gold-hover transition-all duration-300 flex items-center justify-center gap-2 group"
          >
            Book Your Consultation
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </button>
          <a
            href="tel:+919914601473"
            data-testid="cta-call-btn"
            className="border border-gold/30 text-gold px-10 py-4 text-sm font-medium tracking-wide hover:bg-gold hover:text-navy-dark transition-all duration-300 flex items-center justify-center gap-2"
          >
            <Phone className="w-4 h-4" />
            Or call us directly
          </a>
        </div>
      </div>
    </section>
  );
}
